import { MultiUnarchivePasswordEntry } from "./MultiUnarchivePasswordEntry";

export class MultiUnarchivePasswordRequest {
    entries: MultiUnarchivePasswordEntry[] = [];
}